export type { ComponentMeta } from './state/modules/components-meta'
export { ComponentIcon } from './state/modules/components-meta'
